// extracted by mini-css-extract-plugin
export default {"container":"QY-z","title":"RY-z","link":"SY-z"};